import { render, staticRenderFns } from "./task1_1.vue?vue&type=template&id=225d1457&scoped=true&"
import script from "./task1_1.vue?vue&type=script&lang=js&"
export * from "./task1_1.vue?vue&type=script&lang=js&"
import style0 from "./task1_1.vue?vue&type=style&index=0&id=225d1457&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225d1457",
  null
  
)

export default component.exports